/** Per-level infection profile for the Virus tower.
 *  Single source of truth for all infection scaling; consulted at impact time.
 *  B-up2 (hazard pool) and B2 (synergies) attach by reading this output.
 */
export interface VirusProfile {
  tickDamage: number;
  tickInterval: number;
  duration: number;
  zoneRadius: number;
  spreadRadius: number;
  spreadChance: number;
  maxGenerations: number;
  spreadInterval: number;
  speedDebuff: number; // 0..1 movement multiplier while infected (1 = none)
  hazardPoolDuration: number; // ms the post-impact hazard pool lingers (0 = none)
}

/** Per-level infection profiles, index 0 = level 1.
 *  Level-1 row MUST equal public/data/towers.json virus.special (asserted by test). */
export const VIRUS_LEVEL_PROFILE: readonly VirusProfile[] = [
  {
    tickDamage: 6,
    tickInterval: 600,
    duration: 4000,
    zoneRadius: 60,
    spreadRadius: 40,
    spreadChance: 0.5,
    maxGenerations: 2,
    spreadInterval: 700,
    speedDebuff: 0.9,
    hazardPoolDuration: 0,
  },
  {
    tickDamage: 8,
    tickInterval: 600,
    duration: 4000,
    zoneRadius: 65,
    spreadRadius: 40,
    spreadChance: 0.6,
    maxGenerations: 2,
    spreadInterval: 700,
    speedDebuff: 0.9,
    hazardPoolDuration: 0,
  },
  {
    tickDamage: 10,
    tickInterval: 600,
    duration: 5000,
    zoneRadius: 72,
    spreadRadius: 40,
    spreadChance: 0.7,
    maxGenerations: 2,
    spreadInterval: 700,
    speedDebuff: 0.9,
    hazardPoolDuration: 0,
  },
  {
    tickDamage: 12,
    tickInterval: 600,
    duration: 5000,
    zoneRadius: 80,
    spreadRadius: 40,
    spreadChance: 0.7,
    maxGenerations: 3,
    spreadInterval: 700,
    speedDebuff: 0.8,
    hazardPoolDuration: 0,
  },
  {
    tickDamage: 15,
    tickInterval: 600,
    duration: 5000,
    zoneRadius: 90,
    spreadRadius: 40,
    spreadChance: 0.8,
    maxGenerations: 4,
    spreadInterval: 700,
    speedDebuff: 0.8,
    hazardPoolDuration: 3000,
  },
];

/** Clamp level (1..5) and return the infection profile for it. */
export function virusInfectionProfile(level: number): VirusProfile {
  const idx = Math.max(
    0,
    Math.min(VIRUS_LEVEL_PROFILE.length - 1, Math.round(level) - 1),
  );
  return VIRUS_LEVEL_PROFILE[idx]!;
}
